module.exports = __webpack_public_path__ + "media/images/gusto_logo-3d2a6db8b42e5936680742b841e30e0c.jpeg";